import I18n from 'i18n-js';

import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import BottomSheetDialog from '~/components/molecules/BottomSheetDialog';
import { ANIMATED_ROOT_POPUP_ID } from '~/components/molecules/BottomSheetDialog/utils';

import RankingTimer from '~/views/CollectionView/CollectionRanking/CollectionRankingDialogs/RankingTimer';

import styles from './CollectionRankingDesyncPopup.module.scss';

type TCollectionRankingDesyncPopupProps = {
  collectionId: string;
  close: () => void;
  collectionName: string;
  animateRootPopup: boolean;
};

export function CollectionRankingDesyncPopup({
  collectionId,
  collectionName,
  close,
  animateRootPopup,
}: TCollectionRankingDesyncPopupProps): JSX.Element {
  return (
    <BottomSheetDialog
      onClose={close}
      header={collectionName}
      elementIdToAnimate={animateRootPopup ? ANIMATED_ROOT_POPUP_ID : null}
      contentClassName={styles.container}
      renderFooter={({ closeDialog }) => (
        <StyledButton
          variant={EStyledButtonVariant.BLUE}
          onClick={closeDialog}
          className={styles.footerButton}
        >
          {I18n.t('common_okay')}
        </StyledButton>
      )}
    >
      <h4 className={styles.headline}>
        {I18n.t('collections_ranking_headline')}
      </h4>
      <p className={styles.text}>
        {I18n.t('collections_ranking_update_bs_sub')}
      </p>
      <RankingTimer
        collectionId={collectionId}
        className={styles.timer}
      />
    </BottomSheetDialog>
  );
}
